import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 350vh;
  justify-content: unset;

  @media (max-width: ${breakpoints.xl}) {
    margin-top: 20vh;
  }
`;

export const ImageContainer = styled.div`
  box-sizing: border-box;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
`;

export const BottomGradient = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3vh;
  background: ${({ theme }) =>
    `linear-gradient(${theme.colors.secondary}00, ${theme.colors.secondary}FF)`};
`;
